var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramWhite181(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0_35_126)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_35_126",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_35_126",
    transform: "translate(-0.00641026) scale(0.0128205)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_35_126",
    width: 79,
    height: 78,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABOCAMAAABWtrsRAAAAM1BMVEVHcEzn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+exRWCXAAAAEHRSTlMA4GCg8FAwQIDAcBDQILCQ+Tyb0AAAAAlwSFlzAAALEgAACxIB0t1+/AAAAUBJREFUWIXt1tuSgyAMBmBBDhHUzfs/7U7bbdGE7U5MbrbDfwt+g5Ig0z3V7wHRzXEySQz4E5cNvBkP8WxYGsBTtO+czxyGyqaIshAPQcVtlMPA5kjimYdJ4wHjdDvS8VQfsOOp1mf9/az317r+zPvDun/Nz5fT+afa21eq353h+Tzy75MyAEDJ/P9aM0kbIgPP2qx+PzTA+nWuWdq/2IbIwPLQINAnnL/uRabdF5kuejOd/Yy/5P3KNVDiveFevwmBV5hxjKtCz3W3ogWE3l95/CnsPCzG3mrs4WbsFWNvvuC5cjuBauzV9ir2QmmN3ylHsXc86xIHk9Ar0zG8/7LMc9M5bIFR5hXisT0BmbcRL+o8+rpT0nkL9dgMmcdvwp0ZKm/lM1QevczLPFouWo9fVoY3vOENb3jDG96neYjwDah4voiMcHoHAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite181);
export default __webpack_public_path__ + "static/media/instagram_white_1-8 1.7beb9c794a08a77d4633d0c8c91ec1f7.svg";
export { ForwardRef as ReactComponent };